'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _backgrounds = require('../../helpers/backgrounds');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Column: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1rem',
    boxSizing: 'border-box',
    position: 'relative',
    borderTopStyle: function borderTopStyle(props) {
      return getStyleValue('top', props);
    },
    borderRightStyle: function borderRightStyle(props) {
      return getStyleValue('right', props);
    },
    borderBottomStyle: function borderBottomStyle(props) {
      return getStyleValue('bottom', props);
    },
    borderLeftStyle: function borderLeftStyle(props) {
      return getStyleValue('left', props);
    },
    borderWidth: function borderWidth(props) {
      return getStyleValue('width', props);
    },
    borderColor: function borderColor(props) {
      return getStyleValue('color', props);
    }
  },
  emptyColumn: {
    position: 'relative',
    width: '100%',
    padding: '2rem 0',
    textAlign: 'center',
    color: 'white',
    textShadow: '1px 1px 3px black',
    opacity: 0.5
  }
};
var getWidth = function getWidth(cols) {
  return Math.round(cols / 12 * 10e6) / 10e4 + '%';
};
var getStyleValue = function getStyleValue(style, props) {
  var responsiveMode = props.responsiveMode,
    otherProperties = props.otherProperties;
  var bordersSelector = otherProperties.bordersSelector;
  if (!bordersSelector) return null;
  var borderWidth = bordersSelector.borderWidth,
    borderStyle = bordersSelector.borderStyle,
    top = bordersSelector.top,
    right = bordersSelector.right,
    bottom = bordersSelector.bottom,
    left = bordersSelector.left,
    desktop = bordersSelector.desktop,
    tablet = bordersSelector.tablet,
    mobile = bordersSelector.mobile,
    color = bordersSelector.color;
  if (!desktop && responsiveMode === _ResponsiveModes.DESKTOP || !tablet && responsiveMode === _ResponsiveModes.TABLET || !mobile && responsiveMode === _ResponsiveModes.MOBILE) return null;
  switch (style) {
    case 'top':
      return top ? borderStyle : 'none';
    case 'right':
      return right ? borderStyle : 'none';
    case 'bottom':
      return bottom ? borderStyle : 'none';
    case 'left':
      return left ? borderStyle : 'none';
    case 'width':
      return borderWidth;
    case 'color':
      var r = color.r,
        g = color.g,
        b = color.b,
        a = color.a;
      return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    default:
      return null;
  }
};
var Column = function (_Component) {
  _inherits(Column, _Component);
  function Column() {
    _classCallCheck(this, Column);
    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }
  _createClass(Column, [{
    key: 'render',
    value: function render() {
      var _widths, _offsets;
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        responsiveMode = _props.responsiveMode,
        children = _props.children,
        highlight = _props.highlight,
        editable = _props.editable,
        connectDragPreview = _props.connectDragPreview,
        setActiveContent = _props.setActiveContent,
        wrapWithDropZone = _props.wrapWithDropZone;
      var small = otherProperties.small,
        medium = otherProperties.medium,
        large = otherProperties.large,
        offsetSmall = otherProperties.offsetSmall,
        offsetMedium = otherProperties.offsetMedium,
        offsetLarge = otherProperties.offsetLarge,
        bordersSelector = otherProperties.bordersSelector;
      var backgroundImage = cssProperties.backgroundImage;
      var widths = (_widths = {}, _defineProperty(_widths, _ResponsiveModes.DESKTOP, large), _defineProperty(_widths, _ResponsiveModes.TABLET, medium), _defineProperty(_widths, _ResponsiveModes.MOBILE, small), _widths);
      var offsets = (_offsets = {}, _defineProperty(_offsets, _ResponsiveModes.DESKTOP, offsetLarge), _defineProperty(_offsets, _ResponsiveModes.TABLET, offsetMedium), _defineProperty(_offsets, _ResponsiveModes.MOBILE, offsetSmall), _offsets);
      var processedStyle = _extends({}, cssProperties, {
        width: getWidth(widths[responsiveMode]),
        marginLeft: getWidth(offsets[responsiveMode]),
        backgroundImage: (0, _backgrounds.wrapWithUrl)(backgroundImage, responsiveMode)
      });
      return editable ? connectDragPreview(_react2.default.createElement('div', {
        className: classes.Column,
        style: processedStyle,
        onClick: setActiveContent
      }, highlight, wrapWithDropZone(!!children && !!children.length ? children : _react2.default.createElement('div', {
        className: classes.emptyColumn
      }, 'empty column')))) : _react2.default.createElement('div', {
        className: classes.Column,
        style: processedStyle
      }, children);
    }
  }]);
  return Column;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)(Column);